import ReactEcharts from "echarts-for-react";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import echarts from "echarts";
import "echarts/map/js/china";
import geoJson from "echarts/map/json/china.json";
import { Empty } from "antd-mobile-v5";
interface StatisticalChart {
  xData: any;
  yData: any;
  valueSeries: any[];
}

export interface FieldDescription {
  uuid: string;
  tableName: string;
  fieldName: string;
  fieldShowName: string;
  title?: string;
  inputType: number;
  dictionary?: string;
  aggregateType?: string;
  hasPreDefinedFilters?: boolean;
}

const ChartWrapper = styled.div`
  .chart-list {
    width: 100%;
  }
`;
// const colors = [
//   "#7fb80e",
//   "#f47920",
//   "#69541b",
//   "#EC3B54",
//   "#5824ED",
//   "#3870FF",
//   "#30D7FC",
//   "#2FCF86",
//   "#EED542",
//   "#EF897B",
//   "#8F3FF4",
// ];
const colors = [
  "#789bf2",
  "#ffaaaa",
  "#73ddc3",
  "#fbcb7c",
  "#ffa8e1",
  "#a8bdef",
  "#7ddec6",
  "#2FCF86",
  "#EED542",
  "#EF897B",
  "#8F3FF4",
];

function groupBy(array: any[], fn: any) {
  const groups: any = {};
  array.forEach(function (item) {
    const group = JSON.stringify(fn(item));
    groups[group] = groups[group] || {};
    Object.assign(groups[group], item);
  });
  return Object.keys(groups).map(function (group) {
    return groups[group];
  });
}

interface ChartProps {
  dataSource: any;
  chartType:
    | "bar"
    | "line"
    | "pie"
    | "map"
    | "stripBar"
    | "pileBar"
    | "ring"
    | "funnel";
  description: FieldDescription[];
  height?: number | string;
  isApp?: string;
}

const legendApp = {
  top: 60,
  left: 60,
  right: 5,
  bottom: 30,
};

export default function Chart({
  dataSource,
  chartType,
  description,
  height,
  isApp,
}: ChartProps) {
  const [statisticalChartData, setStatisticalChartData] =
    useState<StatisticalChart | null>({
      xData: null,
      yData: null,
      valueSeries: [],
    });

  const [mapData, setMapData] = useState<{ [key: string]: any }>([]);
  const [mapSeriesName, setMapSeriesName] = useState("");

  useEffect(() => {
    console.log(dataSource);
    if (dataSource && dataSource.data && dataSource.data.length > 0) {
      const dicts = dataSource.dicts;
      const data = JSON.parse(JSON.stringify(dataSource.data));
      const aggFields = dataSource.aggFields;
      const titles = dataSource.titles;
      let dictName: any;
      try {
        dictName =
          description.find(
            (d) =>
              d.dictionary === Object.keys(dicts)[0] &&
              data.some((item: any) =>
                Object.keys(item).some((t) => t === d.fieldName)
              )
          )!?.fieldName || Object.keys(dicts)[0];
      } catch {
        dictName =
          description.find((d) => d.dictionary === Object.keys(dicts)[0])!
            ?.fieldName || Object.keys(dicts)[0];
      }

      const dictVals = Object.keys(dicts).map((key) => dicts[key])[0];
      const newData: any[] = [];
      data.forEach((item: any) => {
        item.source =
          dictVals &&
          dictVals.some((val: { uuid: string }) => val.uuid === item[dictName])
            ? dictVals.find(
                (val: { uuid: string }) => val.uuid === item[dictName]
              ).name
            : "";
        const newObj: any = {};
        if (item.index || item.index === 0) {
          for (const a in item) {
            if (
              a !== dictName &&
              // a !== "name" &&
              a !== "index" &&
              a !== "source"
            ) {
              newObj[a + item.index] = item[a];
            } else {
              newObj[a] = item[a];
            }
          }
          newData.push(newObj);
        } else {
          newData.push(item);
        }
      });

      const groupArray = groupBy(newData, function (item: any) {
        return [item.source];
      });

      const obj: any = {};
      if (chartType === "stripBar") {
        obj.xData = {
          type: "value",
          boundaryGap: [0, 0.01],
        };

        obj.yData = {
          type: "category",
          data: groupArray.map((item: { source: string }) => item.source),
        };
      } else {
        obj.xData = [
          {
            type: "category",
            data: groupArray.map((item: { source: string }) => item.source),
          },
        ];
        obj.yData = [
          {
            type: "value",
            axisLine: {
              show: true,
            },
            splitLine: {
              lineStyle: {
                type: "solid",
              },
            },
          },
        ];
      }

      const standardData: any[] = [];
      aggFields.forEach((agg: string, indx: number) => {
        const standardObj: any = {};
        standardObj.type =
          chartType === "pileBar" || chartType === "stripBar"
            ? "bar"
            : chartType;

        standardObj.data = groupArray.map((d: { [x: string]: any }) => d[agg]);
        standardObj.name = titles[indx];
        if (chartType === "pileBar") {
          standardObj.stack = "true";
        }
        standardData.push(standardObj);
      });
      if (chartType === "map") {
        const mapArr = obj.xData[0].data.map((x: any, i: number) => ({
          name: x ? x.slice(0, x.length - 1) : "",
          value: standardData[0].data[i],
        }));
        setMapData(mapArr);
        setMapSeriesName(standardData[0].name);
      }
      if (
        chartType === "pie" ||
        chartType === "ring" ||
        chartType === "funnel"
      ) {
        const pieData = {
          name: standardData[0].name,
          type: chartType === "funnel" ? "funnel" : "pie",
          data: obj.xData[0].data.map((x: any, i: number) => ({
            name: x,
            value: standardData[0].data[i],
          })),
        };
        obj.valueSeries = [pieData];
      } else {
        obj.valueSeries = standardData;
      }
      if (chartType === "bar" && obj.valueSeries.length === 1) {
        obj.valueSeries[0].barWidth = 60;
      }
      setStatisticalChartData(obj);
    } else {
      setStatisticalChartData(null);
    }
  }, [chartType, dataSource, description]);

  useEffect(() => {
    if (chartType !== "map") return;
    if (
      statisticalChartData &&
      statisticalChartData.valueSeries.length > 0 &&
      statisticalChartData.xData.length > 0
    ) {
      echarts.registerMap("china", geoJson);
      const element = document.getElementById("map");
      const chart: any = echarts.init(element as HTMLDivElement);
      chart.setOption({
        xAxis: {
          show: false,
          scale: false, //值是否只在数轴中有效
        },
        yAxis: {
          show: false,
        },
        // 修改图例
        // legend: {
        //   left: 10,
        // },
        tooltip: {
          trigger: "item",
          // formatter: function (params: any) {
          //   return `
          //   <div>
          //     <div>
          //       商机：<span>${
          //         params.data.shangji == null ? 0 : params.data.shangji
          //       }</span>
          //     </div>
          //     <div>
          //       投资经理：<span>${
          //         params.data.touzijingli == null ? 0 : params.data.touzijingli
          //       }</span>
          //     </div>
          //     <div>
          //       渠道商：<span>${
          //         params.data.qudaoshang == null ? 0 : params.data.qudaoshang
          //       }</span>
          //     </div>
          //   </div>
          // `;
          // },
          // backgroundColor: "rgba(41,41,55,0.95)",
          // padding: [12, 14],
          // textStyle: {
          //   color: "rgba(255,255,255,0.74)",
          //   fontWeight: 400,
          //   fontFamily: "PingFangSC-Regular, PingFang SC",
          //   fontSize: 12,
          //   lineHeight: 12,
          // },
        },
        // 图元映射
        visualMap: [
          {
            type: "piecewise", //分段
            show: true,
            itemWidth: 27,
            itemHeight: 14,
            align: "left",
            x: 3,
            y: "bottom",
            seriesIndex: 0,
            pieces: [
              {
                min: 1000000,
                label: "高",
                symbol: "rect",
                color: "rgba(0,98,255,1)",
              },
              {
                min: 500000,
                max: 1000000,
                label: " ",
                symbol: "rect",
                color: "rgba(0,98,255,0.8)",
              },
              {
                min: 100000,
                max: 500000,
                label: " ",
                symbol: "rect",
                color: "rgba(0,98,255,0.6)",
              },
              {
                min: 10000,
                max: 100000,
                label: " ",
                symbol: "rect",
                color: "rgba(0,98,255,0.4)",
              },
              {
                min: 1000,
                max: 10000,
                label: " ",
                symbol: "rect",
                color: "rgba(0,98,255,0.2)",
              },
              {
                min: 0,
                max: 1000,
                label: "低",
                symbol: "rect",
                color: "rgba(0,98,255,0.1)",
              }, // 不指定 min，表示 min 为无限大（-Infinity）。
            ],
          },
          // {
          //   type: "piecewise", //分段
          //   show: false,
          //   align: "left",
          //   right: 26,
          //   y: "bottom",
          //   itemWidth: 6,
          //   itemHeight: 6,
          //   seriesIndex: 1,
          //   pieces: [
          //     {
          //       min: 0,
          //       max: 40,
          //       label: "预警",
          //       symbol: "circle",
          //       color: "#FF2129",
          //     },
          //   ],
          // },
        ],
        geo: {
          map: "china",
          show: true,
          roam: false, //不开启缩放
          selectedMode: true, //是否开启多选模式
          itemStyle: {
            normal: {
              show: false, //显示省份标签
              borderWidth: 0.2,
              borderType: "dashed", //描边类型
              borderColor: "#999",
            },
            emphasis: {
              show: false, //对应的鼠标悬浮效果(是否显示地区名称)
              // areaColor: "transparent", //高亮时鼠标悬浮背景色
              borderWidth: 2,
              borderType: "dashed", //描边类型
              borderColor: "#333",
              textStyle: {
                color: "#fff",
              },
            },
          },
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                areaColor: "#272736", //地图区域颜色
              },
            },
          ],
        },
        series: [
          {
            name: mapSeriesName,
            type: "map",
            // mapType: "china",
            roam: false, //是否开启鼠标缩放
            zoom: 0.8, //当前视角的地图缩放比例
            geoIndex: 0,
            data: mapData,
          },
          // {
          //   name: "预警",
          //   type: "effectScatter",
          //   symbolSize: 10,
          //   symbol: "circle",
          //   rippleEffect: {
          //     color: "#FF2129",
          //     brushType: "fill",
          //   },
          //   coordinateSystem: "geo", //使用坐标系
          //   tooltip: {
          //     show: true, //是否显示提示框组件
          //     formatter: `{a}`,
          //     backgroundColor: "#FBFBFB",
          //     padding: 12,
          //     extraCssText: "box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);", //浮层框额外样式
          //     textStyle: {
          //       color: "#000",
          //       fontWeight: 500,
          //       fontFamily: "SFProText-Medium, SFProText",
          //       fontSize: 14,
          //     },
          //   },
          //   // itemStyle: {
          //   //   color: "#fff",
          //   // },

          //   data: [
          //     [112.53, 37.87], //填写省份经纬度
          //   ],
          // },
        ],
      });
    }
  }, [mapData, chartType, statisticalChartData, mapSeriesName]);

  return (
    <ChartWrapper>
      {statisticalChartData ? (
        <>
          {statisticalChartData.valueSeries.length > 0 &&
          statisticalChartData.xData ? (
            <div className="chart-list">
              {chartType === "bar" || chartType === "pileBar" ? (
                <ReactEcharts
                  style={{ height: height || 400 }}
                  key={Date.now()}
                  option={{
                    color: colors,
                    grid: isApp
                      ? legendApp
                      : {
                          top: 40,
                          left: 100,
                          right: 80,
                          bottom: 60,
                        },
                    legend: {
                      type: "scroll",
                      orient: "horizontal",
                      left: "center",
                      top: 0,
                    },
                    tooltip: {
                      trigger: "axis",
                      axisPointer: {
                        type: "shadow",
                      },
                    },
                    xAxis: statisticalChartData.xData,
                    yAxis: statisticalChartData.yData,
                    series: statisticalChartData.valueSeries,
                    dataZoom: [
                      {
                        show:
                          statisticalChartData.xData &&
                          Array.isArray(statisticalChartData.xData) &&
                          statisticalChartData.xData.length > 0 &&
                          statisticalChartData.xData[0].data.length > 4
                            ? true
                            : false, // 为true 滚动条出现
                        realtime: true,
                        type: "slider", // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
                        // @ts-ignore
                        height: 15,
                        // start: 0, // 表示默认展示20%～80%这一段。
                        // end: 30,
                        startValue: 0, //一页的数量
                        endValue: 3,
                      },
                    ],
                  }}
                />
              ) : chartType === "line" || chartType === "stripBar" ? (
                <ReactEcharts
                  style={{ height: height || 400 }}
                  key={Date.now()}
                  option={{
                    color: colors,
                    grid: isApp
                      ? legendApp
                      : {
                          top: 40,
                          left: 100,
                          right: 80,
                          bottom: 20,
                        },
                    legend: {
                      type: "scroll",
                      orient: "horizontal",
                      left: "center",
                      top: 0,
                    },
                    tooltip: {
                      trigger: "axis",
                      axisPointer: {
                        type: "shadow",
                      },
                    },
                    xAxis: statisticalChartData.xData,
                    yAxis: statisticalChartData.yData,
                    series: statisticalChartData.valueSeries,
                  }}
                />
              ) : chartType === "pie" || chartType === "ring" ? (
                <>
                  {statisticalChartData.valueSeries[0].data.length > 0 && (
                    <ReactEcharts
                      key={Date.now()}
                      style={{ height: height || 400 }}
                      option={{
                        color: colors,
                        tooltip: {
                          trigger: "item",
                          formatter: "{a} <br/>{b}: {c} ({d}%)",
                        },
                        legend: {
                          left: "left",
                          type: "scroll",
                        },
                        series: [
                          {
                            name: statisticalChartData.valueSeries[0].name,
                            type: "pie",
                            radius:
                              chartType === "pie" ? "75%" : ["40%", "70%"],
                            center: ["50%", "55%"],
                            data: statisticalChartData.valueSeries[0].data,
                            emphasis: {
                              itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                              },
                            },
                          },
                        ],
                      }}
                    />
                  )}
                </>
              ) : chartType === "funnel" ? (
                <>
                  {statisticalChartData.valueSeries[0].data.length > 0 && (
                    <ReactEcharts
                      key={Date.now()}
                      style={{ height: height || 400 }}
                      option={{
                        backgroundColor: "transparent",
                        color: colors,
                        tooltip: {
                          trigger: "item",
                          formatter: "{b} : {c}",
                        },
                        series: [
                          {
                            name: statisticalChartData.valueSeries[0].name,
                            type: "funnel",
                            labelLine: {
                              length: 10,
                              lineStyle: {
                                width: 1,
                                type: "solid",
                              },
                            },
                            itemStyle: {
                              borderColor: "#fff",
                              borderWidth: 1,
                            },
                            left: "10%",
                            top: 60,
                            bottom: 60,
                            width: "80%",
                            min: 0,
                            max: 100,
                            minSize: "0%",
                            maxSize: "100%",
                            label: {
                              show: true,
                              position: "inside",
                            },
                            data: statisticalChartData.valueSeries[0].data,
                            emphasis: {
                              itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                              },
                            },
                          },
                        ],
                      }}
                    />
                  )}
                </>
              ) : chartType === "map" ? (
                <div
                  id="map"
                  style={{
                    height: height || 400,
                    width: "100%",
                    display: "flex",
                  }}
                ></div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <div
              style={{
                border: "1px solid #f0f0f0",
                marginTop: 14,
                padding: "40px 0",
              }}
            >
              <></>
            </div>
          )}
        </>
      ) : (
        <Empty style={{ height: 340 }} description="暂无数据" />
      )}
    </ChartWrapper>
  );
}
